import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { manufacturerList } from "../constants/manufacturer";

export const getManufacturerList = async (
  dispatch,
  { pageNum, filters = null } = {},
) => {
  try {
    const res = await api.manufacturer_list(pageNum, filters);

    dispatch({
      type: manufacturerList,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: manufacturerList,
      payload: error?.response?.data || error,
    });

    authorizedUser(error?.response?.data);
  }
};

export const get_manufacturer_by_ID = async (id) => {
  try {
    const res = await api.get_manufacturer_by_ID(id);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const addManufacturer = async (bodyData) => {
  try {
    const res = await api.add_manufacturer(bodyData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const editManufacturer = async (id, bodyData) => {
  try {
    const res = await api.edit_manufacturer(id, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
